import React from 'react';
import styled from '@emotion/styled';
import Skeleton from './Skeleton';
import breakpoints from '../Theme/breakpoints';

const EventList = styled.div`
  width: 100%;
`;

const ListItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  width: 100%;
  padding: 1rem 0;
`;

const ListImage = styled(Skeleton)`
  height: 4rem;
  width: 2.5rem;
  margin-right: 1.5rem;
`;

const ListText = styled.div`
  flex: 1;  
  height: 100%;
  padding-right: 0.5rem;

  .MuiSkeleton-root {
    width: 100%;

    @media (min-width: ${breakpoints.sm}px) {
      width: 30%;

      &:first-of-type {
        width: 50%;
      }
    }
  }
`;

const ListItem = () => (
  <ListItemContainer>
    <ListImage />
    <ListText>
      <Skeleton />
      <Skeleton />
      <Skeleton />
    </ListText>
  </ListItemContainer>
);

const EventListSkeletonLoader = () => (
  <EventList>
    <ListItem />
    <ListItem />
    <ListItem />
  </EventList>
);

export default EventListSkeletonLoader;
